// extracted by mini-css-extract-plugin
export default {"main-container":"s116sR55DnXopJ+Hjn8O6w==","content":"jZXVNb0gBmtj8S71GGtbeQ=="};